import '../style.css';
import ProfileImage from '../assets/profile.jpg';
import { useEffect, useState } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { ref, uploadBytes, getDownloadURL } from 'firebase/storage';
import { bucketDb } from './helpers/Config';
import malaysiaData from '../components/helpers/states.json';
import axios from 'axios';
import * as XLSX from 'xlsx';
import Calendar from 'react-calendar';

function UploadsModal({ isOpen, onClose, uploads, onDelete }) {
    const [editMode, setEditMode] = useState(false)
    const [editData, setEditData] = useState("");
    const [states, setStates] = useState([]);
    const [districts, setDistricts] = useState([]);
    const [dataId, setDataId] = useState("")
    const [selectedTitle, setSelectedTitle] = useState("")
    const [selectedState, setSelectedState] = useState("");
    const [selectedDistrict, setSelectedDistrict] = useState("");
    const [selectedType, setSelectedType] = useState("");
    const [selectedFormation, setSelectedFormation] = useState("")
    const [selectedRockType, setSelectedRockType] = useState("")
    const [selectedMajorLithology, setSelectedMajorLithology] = useState("")
    const [selectedAge, setSelectedAge] = useState("")
    const [selectedAccess, setSelectedAccess] = useState("")
    const [selectedOrigin, setSelectedOrigin] = useState("")
    const [selectedExcavation, setSelectedExcavation] = useState("")
    const [selectedDescription, setSelectedDescription] = useState("")
    const [selectedYear, setSelectedYear] = useState("")
    const [selectedJournal, setSelectedJournal] = useState("")
    const [loading, setLoading] = useState(false)
    const [participants, setParticipants] = useState([]);
    const [viewParticipant, setViewParticipant] = useState(false);
    const [eventTitle, setEventTitle] = useState("");
    const [speakerName, setSpeakerName] = useState("");
    const [organizer, setOrganizer] = useState("");
    const [agenda, setAgenda] = useState("");
    const [date, setDate] = useState("")
    const [startTime, setStartTime] = useState("")
    const [endTime, setEndTime] = useState("")
    const [venue, setVenue] = useState("")
 
    useEffect(() => {
        if (malaysiaData && malaysiaData.states) {
          setStates(malaysiaData.states);
        }
      }, []);

    const handleStateChange = (event) => {
        const state = event.target.value;
        setSelectedState(state);
        const selectedStateObj = states.find(s => s.name === state);
        setDistricts(selectedStateObj ? selectedStateObj.districts : []);
        setSelectedDistrict("");
    };

    if (!isOpen) return null;

    const handleDelete = (type, id) => {
        if (window.confirm("Are you sure you want to delete this item?")) {
            onDelete(type, id);
        }
    };

    const handleTypeChange = (event) => {
        setSelectedType(event.target.value);
    };

    const handleEditModel = (data) => {
        setEditData("model");
        setDataId(data._id)
        setSelectedTitle(data.name)
        setSelectedState(data.data.state);
        setSelectedType(data.data.discipline)
        setSelectedFormation(data.data.formation)
        setSelectedRockType(data.data.rockType)
        setSelectedMajorLithology(data.data.majorLithology)
        setSelectedAge(data.data.age)
        setSelectedAccess(data.access)
        setSelectedOrigin(data.data.origin)
        setSelectedExcavation(data.data.excavation)
        const selectedStateObj = states.find(s => s.name === data.data.state);
        setDistricts(selectedStateObj ? selectedStateObj.districts : []);
        setSelectedDistrict(data.data.district);
        setEditMode(true);
    };

    const handleEditReport = (data) => {
        setEditData("report");
        setDataId(data._id)
        setSelectedTitle(data.title)
        setSelectedDescription(data.description)
        setSelectedYear(data.year)
        setSelectedJournal(data.journalName)
        setSelectedState(data.state);
        setSelectedType(data.category)
        setSelectedFormation(data.formation)
        setSelectedRockType(data.rockType)
        setSelectedMajorLithology(data.majorLithology)
        setSelectedAge(data.age)
        setSelectedAccess(data.access)
        setSelectedOrigin(data.origin)
        setSelectedExcavation(data.excavation)
        const selectedStateObj = states.find(s => s.name === data.state);
        setDistricts(selectedStateObj ? selectedStateObj.districts : []);
        setSelectedDistrict(data.district);
        setEditMode(true);
    }

    const handleEditMedia = (data) => {
        setEditData("media");
        setDataId(data._id)
        setSelectedTitle(data.name)
        setSelectedState(data.state);
        setSelectedType(data.category)
        setSelectedFormation(data.formation)
        setSelectedRockType(data.rockType)
        setSelectedMajorLithology(data.majorLithology)
        setSelectedAge(data.age)
        setSelectedAccess(data.access)
        setSelectedOrigin(data.origin)
        setSelectedExcavation(data.excavation)
        const selectedStateObj = states.find(s => s.name === data.state);
        setDistricts(selectedStateObj ? selectedStateObj.districts : []);
        setSelectedDistrict(data.districts);
        setEditMode(true);
    }

    const handleEditEvents = (data) => {
        setEditData("event");
        setDataId(data._id)
        setEventTitle(data.title)
        setSpeakerName(data.speakerName)
        setOrganizer(data.organizer)
        setAgenda(data.agenda)
        setDate(data.date)
        setStartTime(data.startTime)
        setEndTime(data.endTime)
        setVenue(data.venue)
        setEditMode(true)
    }

    const handleSubmitEdit = async () => {
        if (editData === 'media') {
            try{
                setLoading(true)

                const mediaData = {
                    name: selectedTitle,
                    location: `${selectedDistrict}, ${selectedState}`,
                    category: selectedType,
                    state: selectedState,
                    districts: selectedDistrict,
                    access: selectedAccess,
                    formation: selectedFormation,
                    rockType: selectedRockType,
                    majorLithology: selectedMajorLithology,
                    age: selectedAge,
                    origin: selectedOrigin,
                    excavation: selectedExcavation
                }
                const response = await axios.put(`https://geoid-rest.vercel.app/media/${dataId}`, mediaData);
            }catch(error) {
                alert(error)
            }finally {
                toast.success(`Media title "${selectedTitle}" updated!`)
                setLoading(false)
                handleCancel()
                onClose()
            }
        } else if (editData === 'report') {
            try{
                setLoading(true)

                const reportData = {
                    title: selectedTitle,
                    category: selectedType,
                    state: selectedState,
                    district: selectedDistrict,
                    journalName: selectedJournal,
                    description: selectedDescription,
                    access: selectedAccess,
                    formation: selectedFormation,
                    rockType: selectedRockType,
                    majorLithology: selectedMajorLithology,
                    age: selectedAge,
                    origin: selectedOrigin,
                    excavation: selectedExcavation
                }
                const response = await axios.put(`https://geoid-rest.vercel.app/paper_report/${dataId}`, reportData);
            }catch(error) {
                alert(error)
            }finally {
                toast.success(`Report title "${selectedTitle}" updated!`)
                setLoading(false)
                handleCancel()
                onClose()
            }
        } else if (editData === 'model') {
            try{
                setLoading(true)

                const modelData = {
                    title: selectedTitle,
                    category: selectedType,
                    state: selectedState,
                    district: selectedDistrict,
                    access: selectedAccess,
                    formation: selectedFormation,
                    rockType: selectedRockType,
                    majorLithology: selectedMajorLithology,
                    age: selectedAge,
                    origin: selectedOrigin,
                    excavation: selectedExcavation
                }
                const response = await axios.put(`https://geoid-rest.vercel.app/models/${dataId}`, modelData);
            }catch(error) {
                alert(error)
            }finally {
                toast.success(`Model name "${selectedTitle}" updated!`)
                setLoading(false)
                handleCancel()
                onClose()
            }
        } else if (editData === 'event') {
            try{
                setLoading(true)

                const eventData = {
                    title: eventTitle,
                    speakerName: speakerName,
                    organizer: organizer,
                    agenda: agenda,
                    venue: venue,
                    date: date,
                    startTime: startTime,
                    endTime: endTime
                }
                const response = await axios.put(`https://geoid-rest.vercel.app/events/${dataId}`, eventData);
            }catch(error) {
                alert(error)
            }finally {
                toast.success(`Event name "${eventTitle}" updated!`)
                setLoading(false)
                handleCancel()
                onClose()
            }
        }
    }

    const handleCancel = () => {
        setEditData("report");
        setDataId("")
        setSelectedTitle("")
        setSelectedDescription("")
        setSelectedYear("")
        setSelectedJournal("")
        setSelectedState("");
        setSelectedType("")
        setSelectedFormation("")
        setSelectedRockType("")
        setSelectedMajorLithology("")
        setSelectedAge("")
        setSelectedAccess("")
        setSelectedOrigin("")
        setSelectedExcavation("")
        setSelectedDistrict("");
        setEditMode(false)

    }

    const handleCloseView = () => {
        setViewParticipant(false)
    }

    const handleViewParticipants = (event) => {
        setViewParticipant(true)
        setParticipants(event.participant);
    };

    const downloadExcel = () => {
        // Prepare data for export
        const exportData = participants.map(participant => {
            const event = uploads.events.find(event => event.participant.includes(participant));
            return {
                'Title': event?.title || '',
                'Date': event?.date || '',
                'Name': participant.name || '',
                'Address': participant.address || '',
                'Email': participant.email || '',
                'Phone': participant.phoneNumber || '',
                'IGM Membership': participant.igmMembership || '',
                'Payment Ref No': participant.transferRefNo || ''
            };
        });

        // Create worksheet
        const ws = XLSX.utils.json_to_sheet(exportData);
        
        // Create workbook
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Participants');
        
        // Generate Excel file
        XLSX.writeFile(wb, 'participants.xlsx');
    };

    return (
        <div className="modal-overlay">
            {loading && (
                <div className="loading-overlay">
                    <div className="spinner"></div>
                </div>
            )}
            {(!editMode && !viewParticipant) && (
                <>
                    <div className="modal-content-upload uploads-modal">
                        <h2>My Uploads</h2>
                        <div className="uploads-section">
                            <h3>Models</h3>
                            {uploads.models.length > 0 ? (
                                <ul>
                                    {uploads.models.map((model, index) => (
                                        <li key={index}>
                                            <span>{model.name || `Model ${index + 1}`}</span>
                                            <div 
                                                aria-label="Delete model"
                                            >
                                                <button 
                                                    className="edit-button" 
                                                    onClick={() => handleEditModel(model)}>
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-pencil-square" viewBox="0 0 16 16">
                                                        <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z"/>
                                                        <path fill-rule="evenodd" d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5z"/>
                                                    </svg>
                                                </button>
                                                <button
                                                    className="delete-button" 
                                                    onClick={() => handleDelete('model', model._id)}>
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-trash3-fill" viewBox="0 0 16 16">
                                                        <path d="M11 1.5v1h3.5a.5.5 0 0 1 0 1h-.538l-.853 10.66A2 2 0 0 1 11.115 16h-6.23a2 2 0 0 1-1.994-1.84L2.038 3.5H1.5a.5.5 0 0 1 0-1H5v-1A1.5 1.5 0 0 1 6.5 0h3A1.5 1.5 0 0 1 11 1.5m-5 0v1h4v-1a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5M4.5 5.029l.5 8.5a.5.5 0 1 0 .998-.06l-.5-8.5a.5.5 0 1 0-.998.06m6.53-.528a.5.5 0 0 0-.528.47l-.5 8.5a.5.5 0 0 0 .998.058l.5-8.5a.5.5 0 0 0-.47-.528M8 4.5a.5.5 0 0 0-.5.5v8.5a.5.5 0 0 0 1 0V5a.5.5 0 0 0-.5-.5"/>
                                                    </svg>
                                                </button>
                                            </div>
                                        </li>
                                    ))}
                                </ul>
                            ) : (
                                <p>No models uploaded yet.</p>
                            )}
                        </div>
                        <div className="uploads-section">
                            <h3>Reports</h3>
                            {uploads.reports.length > 0 ? (
                                <ul>
                                    {uploads.reports.map((report, index) => (
                                        <li key={index}>
                                            <span>{(report.title && report.title.length > 55) 
                                                ? `${report.title.substring(0, 55)}...` 
                                                : report.title || `Report ${index + 1}`}
                                            </span>
                                            <div 
                                                aria-label="Delete model"
                                            >
                                                <button className="edit-button" 
                                                onClick={() => handleEditReport(report)}
                                                >
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-pencil-square" viewBox="0 0 16 16">
                                                        <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z"/>
                                                        <path fill-rule="evenodd" d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5z"/>
                                                    </svg>
                                                </button>
                                                <button
                                                    className="delete-button" 
                                                    onClick={() => handleDelete('report', report._id)}>
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-trash3-fill" viewBox="0 0 16 16">
                                                        <path d="M11 1.5v1h3.5a.5.5 0 0 1 0 1h-.538l-.853 10.66A2 2 0 0 1 11.115 16h-6.23a2 2 0 0 1-1.994-1.84L2.038 3.5H1.5a.5.5 0 0 1 0-1H5v-1A1.5 1.5 0 0 1 6.5 0h3A1.5 1.5 0 0 1 11 1.5m-5 0v1h4v-1a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5M4.5 5.029l.5 8.5a.5.5 0 1 0 .998-.06l-.5-8.5a.5.5 0 1 0-.998.06m6.53-.528a.5.5 0 0 0-.528.47l-.5 8.5a.5.5 0 0 0 .998.058l.5-8.5a.5.5 0 0 0-.47-.528M8 4.5a.5.5 0 0 0-.5.5v8.5a.5.5 0 0 0 1 0V5a.5.5 0 0 0-.5-.5"/>
                                                    </svg>
                                                </button>
                                            </div>
                                        </li>
                                    ))}
                                </ul>
                            ) : (
                                <p>No reports uploaded yet.</p>
                            )}
                        </div>
                        <div className="uploads-section">
                            <h3>Multimedia</h3>
                            {uploads.media.length > 0 ? (
                                <ul>
                                    {uploads.media.map((media, index) => (
                                        <li key={index}>
                                            <span>{media.name || `Media ${index + 1}`}</span>
                                            <div>
                                                <button className="edit-button" 
                                                onClick={() => handleEditMedia(media)}
                                                >
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-pencil-square" viewBox="0 0 16 16">
                                                        <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z"/>
                                                        <path fill-rule="evenodd" d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5z"/>
                                                    </svg>
                                                </button>
                                                <button 
                                                className="delete-button" 
                                                onClick={() => handleDelete('media', media._id)}
                                                aria-label="Delete media"
                                                >
                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-trash3-fill" viewBox="0 0 16 16">
                                                    <path d="M11 1.5v1h3.5a.5.5 0 0 1 0 1h-.538l-.853 10.66A2 2 0 0 1 11.115 16h-6.23a2 2 0 0 1-1.994-1.84L2.038 3.5H1.5a.5.5 0 0 1 0-1H5v-1A1.5 1.5 0 0 1 6.5 0h3A1.5 1.5 0 0 1 11 1.5m-5 0v1h4v-1a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5M4.5 5.029l.5 8.5a.5.5 0 1 0 .998-.06l-.5-8.5a.5.5 0 1 0-.998.06m6.53-.528a.5.5 0 0 0-.528.47l-.5 8.5a.5.5 0 0 0 .998.058l.5-8.5a.5.5 0 0 0-.47-.528M8 4.5a.5.5 0 0 0-.5.5v8.5a.5.5 0 0 0 1 0V5a.5.5 0 0 0-.5-.5"/>
                                                </svg>
                                            </button>
                                            </div>
                                        </li>
                                    ))}
                                </ul>
                            ) : (
                                <p>No multimedia uploaded yet.</p>
                            )}
                        </div>
                        <div className="uploads-section">
                            <h3>Events</h3>
                            {uploads.events.length > 0 ? (
                                <ul>
                                    {uploads.events.map((events, index) => (
                                        <li key={index}>
                                            <span>{events.title || `Event ${index + 1}`}</span>
                                            <div>
                                                <button className="edit-button" 
                                                    onClick={() => handleEditEvents(events)}
                                                >
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-pencil-square" viewBox="0 0 16 16">
                                                        <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z"/>
                                                        <path fill-rule="evenodd" d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5z"/>
                                                    </svg>
                                                </button>
                                                <button className="edit-button" 
                                                    onClick={() => handleViewParticipants(events)}
                                                >
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-eye-fill" viewBox="0 0 16 16">
                                                    <path d="M10.5 8a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0"/>
                                                    <path d="M0 8s3-5.5 8-5.5S16 8 16 8s-3 5.5-8 5.5S0 8 0 8m8 3.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7"/>
                                                    </svg>
                                                </button>
                                                <button 
                                                className="delete-button" 
                                                onClick={() => handleDelete('events', events._id)}
                                                aria-label="Delete event"
                                                >
                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-trash3-fill" viewBox="0 0 16 16">
                                                    <path d="M11 1.5v1h3.5a.5.5 0 0 1 0 1h-.538l-.853 10.66A2 2 0 0 1 11.115 16h-6.23a2 2 0 0 1-1.994-1.84L2.038 3.5H1.5a.5.5 0 0 1 0-1H5v-1A1.5 1.5 0 0 1 6.5 0h3A1.5 1.5 0 0 1 11 1.5m-5 0v1h4v-1a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5M4.5 5.029l.5 8.5a.5.5 0 1 0 .998-.06l-.5-8.5a.5.5 0 1 0-.998.06m6.53-.528a.5.5 0 0 0-.528.47l-.5 8.5a.5.5 0 0 0 .998.058l.5-8.5a.5.5 0 0 0-.47-.528M8 4.5a.5.5 0 0 0-.5.5v8.5a.5.5 0 0 0 1 0V5a.5.5 0 0 0-.5-.5"/>
                                                </svg>
                                            </button>
                                            </div>
                                        </li>
                                    ))}
                                </ul>
                            ) : (
                                <p>No Events uploaded yet.</p>
                            )}
                        </div>
                        <button className="modal-close-button" onClick={onClose}>Close</button>
                    </div>  
                </>
            )}

            {editMode && editData === 'event' && (
                <>
                    <div className="modal-content-upload uploads-modal">
                        <h2>Edit</h2>

                        <div className='form-group'>
                            <label>Event title</label>
                            <input type="text" onChange={(e) => setEventTitle(e.target.value)} value={eventTitle}/>
                        </div>

                        <div className='form-group'>
                            <label>Speaker's Name</label>
                            <input type="text" onChange={(e) => setSpeakerName(e.target.value)} value={speakerName}/>
                        </div>

                        <div className='form-group'>
                            <label>Organizer</label>
                            <input type="text" onChange={(e) => setOrganizer(e.target.value)} value={organizer}/>
                        </div>

                        <div className='form-group'>
                            <label>Agenda</label>
                            <textarea type="text" onChange={(e) => setAgenda(e.target.value)} value={agenda}/>
                        </div>

                        <div className='form-group'>
                            <label>Venue</label>
                            <div style={{display: 'flex', width: '100%', justifyContent: 'space-evenly'}}>
                                <label>
                                    <input
                                        type="radio"
                                        value="online"
                                        checked={venue === "online"}
                                        onChange={(e) => setVenue(e.target.value)}
                                    />
                                    Online
                                </label>
                                <label>
                                    <input
                                        type="radio"
                                        value="physical"
                                        checked={venue === "physical"}
                                        onChange={(e) => setVenue(e.target.value)}
                                    />
                                    Physical
                                </label>
                            </div>
                        </div>

                        <div className='form-group'>
                            <label>Date</label>
                            <input type="text"
                                value={date ? new Date(date).toLocaleDateString('en-GB', {
                                    day: '2-digit',
                                    month: '2-digit',
                                    year: 'numeric'
                                }) : ''}
                                readOnly
                                className="date-input"/>
                                <Calendar
                                    onChange={setDate}
                                    value={date}
                                    className="calendar"
                                    style={{ width: '100%' }}
                                />
                        </div>

                        <div className='form-group'>
                            <label>Start Time</label>
                            <input aria-label="Time" type="time" value={startTime} onChange={(e) => setStartTime(e.target.value)}/>
                        </div>

                        <div className='form-group'>
                            <label>End Time</label>
                            <input aria-label="Time" type="time" value={endTime} onChange={(e) => setEndTime(e.target.value)}/>
                        </div>

                        <div style={{display: 'flex', justifyContent: 'space-evenly', marginTop: '10px'}}>
                            <button className="modal-cancel-button" onClick={() => handleCancel()}>Cancel</button>
                            <button className="modal-submit-button" onClick={handleSubmitEdit}>Submit</button>
                        </div>
                    </div>
                </>
            )}

            {editMode && editData !== 'event' && (
                <>
                    <div className="modal-content-upload uploads-modal">
                        <h2>Edit</h2>
                        <div>
                                <div className="form-group">
                                    <label>Title</label>
                                    <input type="text" onChange={(e) => setSelectedTitle(e.target.value)} value={selectedTitle}/>
                                </div>
                                <div className="form-group">
                                    <label>State</label>
                                    <select onChange={handleStateChange} value={selectedState}>
                                        <option value="">Select State</option>
                                        {states.map(state => (
                                            <option key={state.name} value={state.name}>
                                            {state.name}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                <div className="form-group">
                                    <label>District</label>
                                    <select onChange={(e) => setSelectedDistrict(e.target.value)} value={selectedDistrict}>
                                        <option value="">Select District</option>
                                        {districts.map(district => (
                                            <option key={district} value={district}>
                                            {district}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                {editData === 'report' &&(
                                    <>
                                        <div className="form-group">
                                            <label>Description</label>
                                            <textarea
                                                value={selectedDescription}
                                                onChange={(e) => setSelectedDescription(e.target.value)}
                                                rows="4"
                                            />
                                        </div>
                                        <div className="form-group">
                                            <label>Year</label>
                                            <input
                                                value={selectedYear}
                                                onChange={(e) => setSelectedYear(e.target.value)}
                                            />
                                        </div>
                                        <div className="form-group">
                                            <label>Journal Name</label>
                                            <input
                                                value={selectedJournal}
                                                onChange={(e) => setSelectedJournal(e.target.value)}
                                            />
                                        </div>
                                    </>
                                )}
                                <div className="form-group">
                                    <label>Discipline</label>
                                    <select onChange={handleTypeChange} value={selectedType}>
                                        <option value="">Discipline</option>
                                        <option value="archaeology"> Archaeology</option>
                                        <option value="gAll">Geology- all</option>
                                        <option value="gGeneral">Geology- general</option>
                                        <option value="gONG"> Geology- oil & gas</option>
                                        <option value="gMining">Geology- mining</option>
                                        <option value="gEngineering">Geology- engineering/ geotechnical</option>
                                        <option value="gEnvironment"> Geology- environment</option>
                                    </select>
                                </div>
                                {selectedType.toLowerCase() !== "archaeology" && selectedType !== "" &&(
                                    <>
                                        <div className="form-group">
                                            <label>Formation</label>
                                            <input type="text" onChange={(e) => setSelectedFormation(e.target.value)} value={selectedFormation}/>
                                        </div>
                                        <div className="form-group">
                                            <label>Rock Type</label>
                                            <input type="text" onChange={(e) => setSelectedRockType(e.target.value)} value={selectedRockType}/>
                                        </div>
                                        <div className="form-group">
                                            <label>Major Lithology</label>
                                            <input type="text" onChange={(e) => setSelectedMajorLithology(e.target.value)} value={selectedMajorLithology}/>
                                        </div>
                                    </>
                                )}
                                {selectedType.toLowerCase() === "archaeology" && selectedType !== "" && (
                                    <>
                                        <div className="form-group">
                                            <label>Origin</label>
                                            <input type="text" onChange={(e) => setSelectedOrigin(e.target.value)} value={selectedOrigin}/>
                                        </div>
                                        <div className="form-group">
                                            <label>Excavation</label>
                                            <input type="text" onChange={(e) => setSelectedExcavation(e.target.value)} value={selectedExcavation}/>
                                        </div>
                                    </>
                                )}
                                <div className="form-group">
                                    <label>Age</label>
                                    <input type="text" onChange={(e) => setSelectedAge(e.target.value)} value={selectedAge}/>
                                </div>
                                <div className="form-group">
                                    <label>Access <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor" class="bi bi-lock" viewBox="0 0 16 16">
                                    <path d="M8 1a2 2 0 0 1 2 2v4H6V3a2 2 0 0 1 2-2m3 6V3a3 3 0 0 0-6 0v4a2 2 0 0 0-2 2v5a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2M5 8h6a1 1 0 0 1 1 1v5a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1"/>
                                    </svg></label>
                                    <select onChange={(e) => setSelectedAccess(e.target.value)} value={selectedAccess}>
                                        <option value="">Select Access</option>
                                        <option value="private">Private (only visible on your profile)</option>
                                        <option value="public">Public (everyone can see)</option>
                                    </select>
                                </div>
                        </div>
                        <div style={{display: 'flex', justifyContent: 'space-evenly', marginTop: '10px'}}>
                            <button className="modal-cancel-button" onClick={() => handleCancel()}>Cancel</button>
                            <button className="modal-submit-button" onClick={handleSubmitEdit}>Submit</button>
                        </div>
                    </div>
                </>
            )}

            {viewParticipant && (
                <>
                 <div className="modal-content-event uploads-modal">
                 <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1rem' }}>
                    <h3>Participants List</h3>
                    <button 
                        onClick={downloadExcel}
                        style={{
                            padding: '8px 16px',
                            backgroundColor: '#4CAF50',
                            color: 'white',
                            border: 'none',
                            borderRadius: '4px',
                            cursor: 'pointer'
                        }}
                    >
                        Download
                    </button>
                </div>
                 <table className="styled-table">
                        <thead>
                            <tr>
                                <th>Title</th>
                                <th>Date</th>
                                <th>Name</th>
                                <th>Address</th>
                                <th>Email</th>
                                <th>Phone</th>
                                <th>IGM Membership</th>
                                <th>Payment Ref No</th>
                                <th>Payment Proof</th>
                            </tr>
                        </thead>
                        <tbody>
                            {participants.length > 0 ? (  // Check if participants exist
                                participants.map((participant, index) => (
                                    <tr key={index}>
                                        <td>{uploads.events.find(event => event.participant.includes(participant)).title}</td>
                                        <td>{uploads.events.find(event => event.participant.includes(participant)).date}</td>
                                        <td>{participant.name}</td>
                                        <td>{participant.address}</td>
                                        <td>{participant.email}</td>
                                        <td>{participant.phoneNumber}</td>
                                        <td>{participant.igmMembership}</td>
                                        <td>{participant.transferRefNo}</td>
                                        <td><a href={participant.paymentProof} target="_blank" rel="noopener noreferrer">View Proof</a></td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="9" style={{ textAlign: 'center' }}>No participants yet.</td>
                                </tr>
                            )}
                        </tbody>
                    </table>

                    <button className="modal-cancel-button" onClick={() => handleCloseView()}>Close</button>
                 </div>
                </>
            )}
        </div>
    );
}

function Profile() {
    const [profileData, setProfileData] = useState({
        username: '',
        biography: '',
        displayName: '',
        address: '',
        tagline: '',
        email: '',
        profile_picture_url: '',
        type: '',
        industry: '',
    });

    const [originalData, setOriginalData] = useState({});
    const [isEditing, setIsEditing] = useState(false);
    const [loading, setLoading] = useState(false);
    const [imageFile, setImageFile] = useState(null);
    const [showUploadsModal, setShowUploadsModal] = useState(false);
    const [userUploads, setUserUploads] = useState({ models: [], reports: [], media: [], events: [] });

    useEffect(() => {
        const fetchProfileData = async () => {
            setLoading(true);
            try {
                const savedUser = JSON.parse(localStorage.getItem('user'));
                const userId = savedUser ? savedUser.user._id : null;

                if (userId) {
                    const response = await fetch(`https://geoid-rest.vercel.app/users/${userId}`);
                    const data = await response.json();
                    setProfileData({
                        id: data.id,
                        username: data.username,
                        biography: data.biography || '',
                        displayName: data.display_name,
                        profile_picture_url: data.profile_picture_url,
                        address: data.address || '',
                        tagline: data.tagline || '',
                        email: data.email,
                        type: data.type,
                        industry: data.industry,
                    });
                    setOriginalData({
                        id: data.id,
                        username: data.username,
                        biography: data.biography || '',
                        displayName: data.display_name,
                        profile_picture_url: data.profile_picture_url || '',
                        address: data.address || '',
                        tagline: data.tagline || '',
                        email: data.email,
                        type: data.type,
                        industry: data.industry,
                    });
                } else {
                    console.error('User ID not found in localStorage');
                }
            } catch (error) {
                console.error('Error fetching profile data:', error);
            } finally {
                setLoading(false);
            }
        };

        fetchProfileData();
    }, []);

    const fetchUserUploads = async () => {
        try {
            setLoading(true)
            const savedUser = JSON.parse(localStorage.getItem('user'));
            const userId = savedUser ? savedUser.user._id : null;
            const modelsResponse = await fetch('https://geoid-rest.vercel.app/models');
            const reportsResponse = await fetch('https://geoid-rest.vercel.app/paper_report');
            const mediaResponse = await fetch('https://geoid-rest.vercel.app/media');
            const eventsResponse = await fetch('https://geoid-rest.vercel.app/events');

            const modelsData = await modelsResponse.json();
            const reportsData = await reportsResponse.json();
            const mediaData = await mediaResponse.json();
            const eventsData = await eventsResponse.json();
            const userModels = modelsData.filter(model => model.userId === userId);
            const userReports = reportsData.filter(report => report.userId === userId);
            const userMedia = mediaData.filter(media => media.userId === userId);
            const userEvents = eventsData.filter(events => events.userId === userId);

            setUserUploads({ models: userModels, reports: userReports, media: userMedia, events: userEvents });
        } catch (error) {
            console.error('Error fetching user uploads:', error);
        } finally {
            setLoading(false)
        }
    };

    const handleShowUploads = () => {
        fetchUserUploads();
        setShowUploadsModal(true);
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setProfileData({
            ...profileData,
            [name]: value
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (isEditing) {
            try {
                setLoading(true);
                const savedUser = JSON.parse(localStorage.getItem('user'));
                const userId = savedUser ? savedUser.user._id : null;

                let profilePictureUrl = profileData.profile_picture_url.url;

                if (imageFile) {
                    const fileRef = ref(bucketDb, `${userId}-${imageFile.name}`);
                    const snapshot = await uploadBytes(fileRef, imageFile);
                    profilePictureUrl = await getDownloadURL(snapshot.ref);
                }

                if (userId) {
                    const response = await fetch(`https://geoid-rest.vercel.app/users/${userId}`, {
                        method: 'PUT',
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify({
                            biography: profileData.biography,
                            display_name: profileData.displayName,
                            address: profileData.address,
                            profile_picture_url: {
                                url: imageFile ? profilePictureUrl : ''
                            },
                            tagline: profileData.tagline,
                            industry: profileData.industry
                        })
                    });

                    if (response.ok) {
                        toast.success("Profile saved successfully!");
                        setIsEditing(false);
                        setOriginalData(profileData);
                    } else {
                        console.error('Failed to update profile');
                    }
                } else {
                    console.error('User ID not found in localStorage');
                }
            } catch (error) {
                console.error('Error updating profile:', error);
            } finally {
                setLoading(false);
            }
        } else {
            setIsEditing(true);
        }
    };

    const handleCancel = () => {
        setProfileData(originalData);  // Reset to original data
        setIsEditing(false);  // Exit editing mode
    };

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            const reader = new FileReader();
            reader.onloadend = () => {
                setProfileData({
                    ...profileData,
                    profile_picture_url: {
                        url: reader.result}
                });
            };
            reader.readAsDataURL(file);
            setImageFile(file);
        }
    };

    const handleUploadClick = () => {
        document.getElementById('fileInput').click(); // Trigger the file input click
    };

    const handleDelete = async (type, id) => {
        try {
            let endpoint;
            if (type === 'model') {
                endpoint = 'models';
            } else if (type === 'report') {
                endpoint = 'paper_report';
            } else if (type === 'media') {
                endpoint = 'media';
            } else if (type === 'events') {
                endpoint = 'events';
            }

            const response = await fetch(`https://geoid-rest.vercel.app/${endpoint}/${id}`, {
                method: 'DELETE',
            });

            if (response.ok) {
                setUserUploads(prevUploads => {
                    const updatedUploads = { ...prevUploads };
                    if (Array.isArray(updatedUploads[type + 's'])) {
                        updatedUploads[type + 's'] = updatedUploads[type + 's'].filter(item => item.id !== id);
                    }
                    return updatedUploads;
                });
                toast.success(`${type.charAt(0).toUpperCase() + type.slice(1)} deleted successfully!`);
            } else {
                toast.error(`Failed to delete ${type}`);
            }
        } catch (error) {
            console.error(`Error deleting ${type}:`, error);
            toast.error(`Error deleting ${type}`);
        }

        fetchUserUploads();
    };

    return (
        <div className="profile-container">
            {loading && (
                <div className="loading-overlay">
                    <div className="spinner"></div>
                </div>
            )}
            <h1>Profile</h1>
            <div className="profile-content">
                <div className="profile-info">
                <div className="profile-image">
                    <input
                        type="file"
                        id="fileInput"
                        accept="image/*"
                        style={{ display: 'none' }} // Hide the input
                        onChange={handleFileChange}
                    />
                    <img 
                        src={profileData.profile_picture_url?.url || ProfileImage} 
                        alt="Profile" 
                    />
                    {isEditing && (
                        <div className="overlay" onClick={handleUploadClick}>
                            <span>Upload Profile Picture</span>
                        </div>
                    )}
                </div>
                    <div className="profile-details">
                        <h2 style={{marginTop: "0px", marginBottom: "0px"}}>{profileData.username}</h2>
                        <p className="profile-type" style={{marginTop: "0px" , marginBottom: "0px"}}>{profileData.type === "owner" ? "Data Owner" : "Data User"}</p>
                        <p style={{marginTop: "0px" }}>{profileData.displayName}</p>
                    </div>
                </div>
                {/* {profileData.type === 'owner' &&( */}
                    <button className="models-button" onClick={handleShowUploads}>My Uploads {'>'}</button>
                {/* )} */}
            </div>

            <form className="profile-form" onSubmit={handleSubmit}>
                <div className="form-group">
                    <label>Username</label>
                    <input type="text" value={profileData.username} readOnly />
                </div>
                <div className="form-group">
                    <label>Biography</label>
                    <input
                        type="text"
                        name="biography"
                        placeholder="Enter your biography"
                        value={profileData.biography}
                        onChange={handleInputChange}
                        disabled={!isEditing}
                        className={isEditing ? 'editing' : ''}
                    />
                </div>
                <div className="form-group">
                    <label>Display Name</label>
                    <input
                        type="text"
                        name="displayName"
                        value={profileData.displayName}
                        onChange={handleInputChange}
                        disabled={!isEditing}
                        className={isEditing ? 'editing' : ''}
                    />
                </div>
                <div className="form-group">
                    <label>Address</label>
                    <input
                        type="text"
                        name="address"
                        placeholder="Enter your address"
                        value={profileData.address}
                        onChange={handleInputChange}
                        disabled={!isEditing}
                        className={isEditing ? 'editing' : ''}
                    />
                </div>
                <div className="form-group">
                    <label>Company</label>
                    <input
                        type="text"
                        name="tagline"
                        placeholder="Describe yourself..."
                        value={profileData.tagline}
                        onChange={handleInputChange}
                        disabled={!isEditing}
                        className={isEditing ? 'editing' : ''}
                    />
                </div>
                <div className="form-group">
                    <label>Email</label>
                    <input type="email" value={profileData.email} readOnly />
                </div>
                <div className="form-group">
                    <label>Industry</label>
                    <input type="text"
                        name="industry"
                        value={profileData.industry}
                        onChange={handleInputChange}
                        disabled={!isEditing}
                        className={isEditing ? 'editing' : ''} />
                </div>
                <div className="button-profile-container">
                    {isEditing && (
                        <button
                            type="button"
                            className="cancel-button"
                            onClick={handleCancel}
                        >
                            Cancel
                        </button>
                    )}
                    <button
                        type="submit"
                        className={`edit-profile-button ${isEditing ? 'save-mode' : ''}`}
                    >
                        {isEditing ? 'Save' : 'Edit Profile'}
                    </button>
                </div>
            </form>
            <ToastContainer />
            <UploadsModal 
                isOpen={showUploadsModal} 
                onClose={() => setShowUploadsModal(false)} 
                uploads={userUploads} 
                onDelete={handleDelete}
            />
        </div>
    );
}

export default Profile;